import { LifetimeStatsSchema } from '@kilat/shared';

import { createRepo } from './_base.js';

/**
 * `tenants/{tid}/stats/lifetime` — the incrementally-maintained counters that
 * tell the dashboard how far along a tenant is (gap G20).
 *
 * One small document, read once per session by `useDisclosureStage`. That is
 * the entire point of maintaining it: the alternative is counting customers and
 * washes with a collection scan on the busiest screen in the product.
 */
export function lifetimeStatsRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/stats`,
    schema: LifetimeStatsSchema,
    name: `tenants/${tenantId}/stats/lifetime`,
  });
}
